/**
 * Family Display Labels — Canonical Source
 *
 * Maps familyId → Dutch display name for all 289 question families.
 * Moved from portals/teacher-v2/utils/familyDisplayNames.ts to content domain
 * so that learner-facing code can use it without cross-portal dependency (BC-V-8).
 */

export const FAMILY_DISPLAY_NAMES: Record<string, string> = {
  // GET (Getalbegrip)
  'GET-BREUK-BASIS': 'Breuken basis',
  'GET-BREUK-DEEL': 'Deel van een geheel',
  'GET-BREUK-GEL-MIN': 'Gelijknamige breuken aftrekken',
  'GET-BREUK-GEL-PLUS': 'Gelijknamige breuken optellen',
  'GET-BREUK-GEMENGD': 'Gemengde breuken',
  'GET-BREUK-GETALLENLIJN': 'Breuken op de getallenlijn',
  'GET-BREUK-KEER': 'Breuken vermenigvuldigen',
  'GET-BREUK-LEZEN': 'Breuken aflezen',
  'GET-BREUK-MIN': 'Breuken aftrekken',
  'GET-BREUK-ONG-PLUS': 'Ongelijknamige breuken optellen',
  'GET-BREUK-UITBREIDEN': 'Breuken uitbreiden',
  'GET-BREUK-VEREENVOUDIG': 'Breuken vereenvoudigen',
  'GET-DEEL-KOMMA': 'Kommagetallen delen',
  'GET-GROOT-AFRONDEN': 'Grote getallen afronden',
  'GET-GROOT-LEZEN': 'Grote getallen lezen',
  'GET-GROOT-POS': 'Positie van grote getallen',
  'GET-GROOT-SCHATTEN': 'Schatten met grote getallen',
  'GET-GROOT-VERGELIJK': 'Grote getallen vergelijken',
  'GET-KOMMA-AFRONDEN': 'Kommagetallen afronden',
  'GET-KOMMA-DEEL': 'Kommagetallen delen',
  'GET-KOMMA-GETALLENLIJN': 'Kommagetallen op de getallenlijn',
  'GET-KOMMA-KEER': 'Kommagetallen vermenigvuldigen',
  'GET-KOMMA-LEZEN': 'Kommagetallen lezen',
  'GET-KOMMA-MIN': 'Kommagetallen aftrekken',
  'GET-KOMMA-PLUS': 'Kommagetallen optellen',
  'GET-KOMMA-VERGELIJK': 'Kommagetallen vergelijken',
  'GET-KOMMA-WAARDE': 'Waarde van kommagetallen',
  'GET-MACHT-GRONDTAL': 'Machten en grondtallen',
  'GET-MACHT': 'Machtsverheffen',
  'GET-NEGATIEF-MIN': 'Negatieve getallen aftrekken',
  'GET-NEGATIEF-PLUS': 'Negatieve getallen optellen',
  'GET-NEGATIEF': 'Negatieve getallen',
  'GET-PROC-AFNAME': 'Procentuele afname',
  'GET-PROC-BASIS': 'Procenten basis',
  'GET-PROC-BTW': 'BTW berekenen',
  'GET-PROC-NIEUW': 'Nieuwe prijs berekenen',
  'GET-PROC-SAMENGESTELD': 'Samengestelde procenten',
  'GET-PROC-TERUG': 'Terugrekenen naar 100%',
  'GET-PROC-TOENAME': 'Procentuele toename',
  'GET-PROC-VAN': 'Procent van een getal',
  'GET-ROND-BASIS': 'Afronden basis',
  'GET-VERGELIJK': 'Getallen vergelijken',
  'GET-VERH-BREUK-PROC-KOPPEL': 'Breuk-procent koppelen',
  'GET-VERH-RECEPT': 'Verhoudingen in recepten',
  'GET-VERH-SCHAAL-KAART': 'Schaal op kaarten',
  'GET-VERH-SCHAAL': 'Schaalberekeningen',
  'GET-VERH-VERDELEN': 'Verhoudingen verdelen',
  'GET-WETENSCHAP-REKEN': 'Wetenschappelijke notatie rekenen',
  'GET-WETENSCHAPPELIJK': 'Wetenschappelijke notatie',
  'GET-WORTEL': 'Worteltrekken',
  'GET-BREUK-BASIS-SLIDER': 'Breuken basis (slider)',
  'GET-GROOT-SCHATTEN-SLIDER': 'Schatten grote getallen (slider)',
  'GET-KOMMA-GETALLENLIJN-SLIDER': 'Kommagetallen getallenlijn (slider)',
  // REK (Rekenen)
  'REK-CIJF-DEEL': 'Cijferend delen',
  'REK-CIJF-KEER': 'Cijferend vermenigvuldigen',
  'REK-CIJF-MIN': 'Cijferend aftrekken',
  'REK-CIJF-PLUS': 'Cijferend optellen',
  'REK-CONTEXT-KEER-DEEL': 'Contextsommen keer/delen',
  'REK-CONTEXT-MEERSTAPS': 'Meerstapssommen',
  'REK-CONTEXT-PLUS-MIN': 'Contextsommen plus/min',
  'REK-GEMENGD-BASIS': 'Gemengd rekenen basis',
  'REK-GEMENGD-TOETS': 'Gemengd rekenen toets',
  'REK-HANDIG-DEEL': 'Handig delen',
  'REK-HANDIG-KEER': 'Handig vermenigvuldigen',
  'REK-HANDIG-PLUS-MIN': 'Handig optellen en aftrekken',
  'REK-SCHATTEN': 'Schatten',
  'REK-TAFELS-BASIS': 'Tafels basis',
  'REK-TAFELS-TOEPASSEN': 'Tafels toepassen',
  'REK-TAFELS-UITBREIDEN': 'Tafels uitbreiden',
  'REK-VOLGORDE': 'Volgorde van bewerkingen',
  // MET (Meten & Meetkunde)
  'MET-COORDINATEN': 'Coördinaten',
  'MET-DRIEHOEK-SOORTEN': 'Soorten driehoeken',
  'MET-GEW-CONTEXT': 'Gewicht in context',
  'MET-GEW-OMREKEN': 'Gewicht omrekenen',
  'MET-GEW-SCHATTEN': 'Gewicht schatten',
  'MET-GEW-WEGEN': 'Wegen',
  'MET-HOEK-BEREKENEN': 'Hoeken berekenen',
  'MET-HOEK-METEN': 'Hoeken meten',
  'MET-HOEK-SOORTEN-CATEGORIZE': 'Hoeksoorten categoriseren',
  'MET-HOEK-SOORTEN': 'Soorten hoeken',
  'MET-HOEK-TEKENEN': 'Hoeken tekenen',
  'MET-INH-BLOK': 'Inhoud van blokken',
  'MET-INH-CITER': 'Inhoud in centiliters',
  'MET-INH-LITER': 'Inhoud in liters',
  'MET-INH-OMREKEN-KUBIEK': 'Kubieke maten omrekenen',
  'MET-INH-OMREKEN': 'Inhoudsmaten omrekenen',
  'MET-INH-SCHATTEN': 'Inhoud schatten',
  'MET-LEN-CONTEXT': 'Lengte in context',
  'MET-LEN-METEN': 'Lengte meten',
  'MET-LEN-NAUWKEURIG': 'Nauwkeurig meten',
  'MET-LEN-OMREKEN': 'Lengtematen omrekenen',
  'MET-LEN-SCHATTEN': 'Lengte schatten',
  'MET-MEETK-CIRKEL-DEEL': 'Delen van een cirkel',
  'MET-MEETK-DIAMETER': 'Diameter en straal',
  'MET-MEETK-OMTREK': 'Omtrek van een cirkel',
  'MET-MEETK-OPP': 'Oppervlakte van een cirkel',
  'MET-OMTREK-RECHT': 'Omtrek van rechthoeken',
  'MET-OPP-DRIEHOEK': 'Oppervlakte driehoek',
  'MET-OPP-LAND': 'Oppervlakte landmaten',
  'MET-OPP-OMREKENEN': 'Oppervlaktematen omrekenen',
  'MET-OPP-PARALLELLOGRAM': 'Oppervlakte parallellogram',
  'MET-OPP-RECHT': 'Oppervlakte rechthoek',
  'MET-OPP-SAMENGESTELD': 'Samengestelde oppervlakte',
  'MET-OPP-VIERKANT': 'Oppervlakte vierkant',
  'MET-SCHAAL-BASIS': 'Schaal basis',
  'MET-SCHAAL-LENGTE': 'Schaal en lengte',
  'MET-SCHAAL-OPP': 'Schaal en oppervlakte',
  'MET-SYMMETRIE': 'Symmetrie',
  'MET-TIJD-METEN': 'Tijd meten',
  'MET-TIJD-NAUWKEURIG': 'Nauwkeurig tijd meten',
  // TIJD (Tijd & Geld)
  'TGL-TIJD-12-24': '12- en 24-uursklok',
  'TGL-TIJD-AFSTAND': 'Afstand en tijd',
  'TGL-TIJD-ANALOOG-GEDETAILLEERD': 'Analoge klok gedetailleerd',
  'TGL-TIJD-ANALOOG': 'Analoge klok',
  'TGL-TIJD-CONVERSIE': 'Tijdconversie',
  'TGL-TIJD-DIAGRAM': 'Tijddiagrammen',
  'TGL-TIJD-DIGITAAL': 'Digitale klok',
  'TGL-TIJD-DUUR': 'Tijdsduur berekenen',
  'TGL-TIJD-GEMIDDELDE': 'Gemiddelde tijd',
  'TGL-TIJD-KALENDER': 'Kalender',
  'TGL-TIJD-OMREKENEN': 'Tijd omrekenen',
  'TGL-TIJD-PLANNING': 'Planning maken',
  'TGL-TIJD-SAMENGESTELD': 'Samengestelde tijdsommen',
  'TGL-TIJD-SCHEMA': 'Schema lezen',
  'TGL-TIJD-SNELHEID': 'Snelheid berekenen',
  'TGL-TIJD-TIJDZONES': 'Tijdzones',
  // GELD
  'TGL-GELD-BOODSCHAPPEN': 'Boodschappen doen',
  'TGL-GELD-BTW': 'BTW berekenen',
  'TGL-GELD-BUDGET': 'Budget beheren',
  'TGL-GELD-KOMMA': 'Geldbedragen met komma',
  'TGL-GELD-KOOPJES': 'Koopjes vergelijken',
  'TGL-GELD-KORTING': 'Korting berekenen',
  'TGL-GELD-MAAK': 'Geldbedragen maken',
  'TGL-GELD-PRIJS-PER': 'Prijs per eenheid',
  'TGL-GELD-RENTE-PROC': 'Rente en procenten',
  'TGL-GELD-SPAREN': 'Sparen',
  'TGL-GELD-TELLEN-TF': 'Geld tellen (waar/onwaar)',
  'TGL-GELD-TELLEN': 'Geld tellen',
  'TGL-GELD-TERUG': 'Teruggeven',
  'TGL-GELD-TERUGREKENEN': 'Terugrekenen met geld',
  'TGL-GELD-WISSEL': 'Wisselgeld',
  'TGL-GELD-WISSELEN': 'Geld wisselen',
  // SWW (Spelling Werkwoordsvormen)
  'SWW-BN-VD-DUBBEL': 'Bijvoeglijk naamwoord (dubbel)',
  'SWW-BN-VD-KORT': 'Bijvoeglijk naamwoord (kort)',
  'SWW-LEEN-ENG-KOF': 'Engelse leenwoorden (kofschip)',
  'SWW-LEEN-ENG-STAM': 'Engelse leenwoorden (stam)',
  'SWW-LEEN-FRANS': 'Franse leenwoorden',
  'SWW-TT-DSTAM': 'Tegenwoordige tijd (d-stam)',
  'SWW-TT-GEBIEDENDE': 'Gebiedende wijs',
  'SWW-TT-INV-JIJ-ERROR': 'Inversie jij (foutenspotter)',
  'SWW-TT-INV-JIJ': 'Inversie jij',
  'SWW-TT-INV-TRICK': 'Inversie trucvragen',
  'SWW-TT-MEERVOUD': 'Meervoud tegenwoordige tijd',
  'SWW-TT-STAM': 'Stam + t',
  'SWW-TT-ZIJN-HEBBEN': 'Zijn en hebben (tt)',
  'SWW-VD-HOMOFOON': 'Voltooid deelwoord (homofoon)',
  'SWW-VD-HULPWW': 'Voltooid deelwoord (hulpww)',
  'SWW-VD-KOF': 'Voltooid deelwoord (kofschip)',
  'SWW-VD-STERK': 'Voltooid deelwoord (sterk)',
  'SWW-VD-ZONDER-GE': 'Voltooid deelwoord (zonder ge-)',
  'SWW-VT-DUBBEL': 'Verleden tijd (dubbel)',
  'SWW-VT-ONREGELMATIG': 'Verleden tijd (onregelmatig)',
  'SWW-VT-STERK': 'Verleden tijd (sterk)',
  'SWW-VT-VZFS': 'Verleden tijd (vzfs)',
  'SWW-VT-ZIJN-HEBBEN': 'Zijn en hebben (vt)',
  'SWW-VT-ZULLEN-KUNNEN': 'Zullen en kunnen (vt)',
  'SWW-VT-ZWAK-KOF': 'Verleden tijd (zwak kofschip)',
  // SPR (Spelling Regels)
  'SPR-ACCENT': 'Accenten',
  'SPR-HOOFDLETTER': 'Hoofdlettergebruik',
  'SPR-KLANK-AA-EE-OO': 'Klanken aa, ee, oo',
  'SPR-KLANK-AU-OU': 'Klanken au en ou',
  'SPR-KLANK-BAKKER': 'Medeklinkerverdubbeling',
  'SPR-KLANK-JAGER-CATEGORIZE': 'Open/gesloten lettergreep (cat.)',
  'SPR-KLANK-JAGER': 'Open en gesloten lettergreep',
  'SPR-KLANK-VERDUBBEL': 'Klinkerverdubbeling',
  'SPR-KLANK-VERKORTEN': 'Klinkerverkorting',
  'SPR-LEEN-C-S-K': 'Leenwoorden c, s, k',
  'SPR-LEEN-ENGELS': 'Engelse leenwoorden',
  'SPR-LEEN-FRANS': 'Franse leenwoorden',
  'SPR-LEEN-GRIEKS': 'Griekse leenwoorden',
  'SPR-LEEN-LATIJN': 'Latijnse leenwoorden',
  'SPR-LEESTEKEN-PUNT-KOMMA': 'Leestekens',
  'SPR-SAM-TUSSEN-N': 'Samenstellingen (tussen-n)',
  'SPR-SAM-TUSSEN-S': 'Samenstellingen (tussen-s)',
  'SPR-TREMA-MV': 'Trema en meervoud',
  'SPR-WEET-D-T-ERROR': 'D of t (foutenspotter)',
  'SPR-WEET-D-T': 'D of t',
  'SPR-WEET-DT': 'Dt-regels',
  'SPR-WEET-EI-IJ': 'Ei of ij',
  // TAA (Taalkunde)
  'TAA-ARGUMENTATIE': 'Argumentatie',
  'TAA-LEZEN-CONCLUSIE': 'Conclusie trekken',
  'TAA-LEZEN-DETAIL': 'Detailvragen',
  'TAA-LEZEN-DOEL': 'Leesdoel bepalen',
  'TAA-LEZEN-FEIT': 'Feit of mening',
  'TAA-LEZEN-KERN': 'Kernzin vinden',
  'TAA-LEZEN-SAMENVATTEN': 'Samenvatten',
  'TAA-LEZEN-SAMENVATTING': 'Samenvatting beoordelen',
  'TAA-LEZEN-STRUCTUUR': 'Tekststructuur',
  'TAA-LEZEN-VERB': 'Verbanden leggen',
  'TAA-LEZEN-VERW': 'Verwijswoorden',
  'TAA-LEZEN-VOORSPEL': 'Voorspellen',
  'TAA-ONT-BASIS': 'Zinsontleding basis',
  'TAA-ONT-BETREKKELIJK': 'Betrekkelijke bijzin',
  'TAA-ONT-BIJZIN': 'Bijzinnen',
  'TAA-ONT-BWB': 'Bijwoordelijke bepaling',
  'TAA-ONT-GEZEGDE': 'Gezegde',
  'TAA-ONT-HOOFDZIN': 'Hoofdzin herkennen',
  'TAA-ONT-INVERSIE': 'Inversie',
  'TAA-ONT-LV-MV': 'Lijdend en meewerkend voorwerp',
  'TAA-ONT-NAAMWOORDELIJK': 'Naamwoordelijk gezegde',
  'TAA-ONT-VOORZETSEL': 'Voorzetselvoorwerp',
  'TAA-SIGNAALWOORD': 'Signaalwoorden',
  'TAA-SOORT-BNW': 'Bijvoeglijk naamwoord',
  'TAA-SOORT-BW': 'Bijwoord',
  'TAA-SOORT-LID': 'Lidwoord',
  'TAA-SOORT-TW': 'Telwoord',
  'TAA-SOORT-VNW': 'Voornaamwoord',
  'TAA-SOORT-VW': 'Voegwoord',
  'TAA-SOORT-VZ': 'Voorzetsel',
  'TAA-SOORT-WW-CATEGORIZE': 'Woordsoorten categoriseren',
  'TAA-SOORT-WW': 'Werkwoord',
  'TAA-TEKSTSOORT': 'Tekstsoorten',
  'TAA-WOORD-ANTONIEM': 'Antoniemen',
  'TAA-WOORD-CONTEXT': 'Woord in context',
  'TAA-WOORD-IDIOOM': 'Idioom en spreekwoorden',
  'TAA-WOORD-SYNONIEM': 'Synoniemen',
  // STU (Studievaardigheden)
  'STU-ALFABET': 'Alfabetische volgorde',
  'STU-BIBLIOTHEEK': 'Bibliotheek gebruiken',
  'STU-CIRKEL': 'Cirkeldiagram lezen',
  'STU-COMBINEER': 'Bronnen combineren',
  'STU-DIAGRAM': 'Diagrammen lezen',
  'STU-FLOWCHART': 'Stroomdiagrammen',
  'STU-GRAFIEK': 'Grafieken lezen',
  'STU-INHOUDSOPGAVE': 'Inhoudsopgave gebruiken',
  'STU-INTERNET': 'Zoeken op internet',
  'STU-KAART': 'Kaart lezen',
  'STU-LIJN': 'Lijndiagram lezen',
  'STU-MINDMAP': 'Mindmap maken',
  'STU-NOTITIES': 'Notities maken',
  'STU-PLANNEN': 'Plannen en organiseren',
  'STU-ROUTE': 'Route beschrijven',
  'STU-SAMENVATTEN': 'Samenvatten (studie)',
  'STU-STAAF': 'Staafdiagram lezen',
  'STU-TABEL': 'Tabellen lezen',
  'STU-TIJDLIJN': 'Tijdlijn lezen',
  'STU-WOORDENBOEK': 'Woordenboek gebruiken',
  // TOPO (Topografie)
  'TOPO-EU-BUURLANDEN': 'Buurlanden van Nederland',
  'TOPO-EU-FYSISCH': 'Fysische kaart Europa',
  'TOPO-EU-GEBERGTE': 'Gebergten in Europa',
  'TOPO-EU-HOOFDST': 'Hoofdsteden Europa',
  'TOPO-EU-KLIMAAT': 'Klimaat in Europa',
  'TOPO-EU-LAND-TF': 'Landen Europa (waar/onwaar)',
  'TOPO-EU-LAND': 'Landen in Europa',
  'TOPO-EU-RIVIEREN': 'Rivieren in Europa',
  'TOPO-EU-ZEEEN': 'Zeeën in Europa',
  'TOPO-KLIMAAT': 'Klimaatzones',
  'TOPO-NL-BUURLANDEN': 'Buurlanden',
  'TOPO-NL-EILANDEN': 'Eilanden van Nederland',
  'TOPO-NL-LANDSCHAP': 'Landschappen Nederland',
  'TOPO-NL-PROV-TF': 'Provincies (waar/onwaar)',
  'TOPO-NL-PROV': 'Provincies',
  'TOPO-NL-STEDEN-REGIO': 'Steden per regio',
  'TOPO-NL-STEDEN': 'Steden in Nederland',
  'TOPO-NL-WATER': 'Water in Nederland',
  'TOPO-WERELD-CONT': 'Continenten',
  'TOPO-WERELD-GEBERGTE': 'Gebergten in de wereld',
  'TOPO-WERELD-HOOFDST': 'Hoofdsteden wereld',
  'TOPO-WERELD-KLIMAAT': 'Klimaat in de wereld',
  'TOPO-WERELD-LANDEN': 'Landen in de wereld',
  'TOPO-WERELD-OCEANEN': 'Oceanen',
  'TOPO-WERELD-RIVIER': 'Rivieren in de wereld'
};

/**
 * Convert a familyId to a human-readable Dutch display name.
 * Uses the FAMILY_DISPLAY_NAMES lookup, with a fallback that
 * strips the module prefix and title-cases the remainder.
 */
export function humanizeFamilyId(familyId: string): string {
  if (FAMILY_DISPLAY_NAMES[familyId]) {
    return FAMILY_DISPLAY_NAMES[familyId];
  }

  // Fallback for unmapped families
  const parts = familyId.split('-').slice(1);
  return parts.join(' ').toLowerCase().replace(/^\w/, c => c.toUpperCase());
}